module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [_c('b-navbar-brand', {
    staticStyle: {
      "padding": "0.475rem 1rem"
    }
  }, [_c('h3', [_vm._v("Reporting")])]), _vm._v(" "), _c('b-button-group', {
    staticClass: "ml-1",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.previousDash
    }
  }, [_vm._v("Analytics")])], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form')], 1)], 1), _vm._v(" "), _c('md-tabs', {
    staticClass: "md-transparent",
    attrs: {
      "md-alignment": "fixed"
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-home",
      "md-label": "Enquiry Analysis"
    }
  }, [_c('b-card', {
    staticClass: "formCard"
  }, [_c('div', {
    staticClass: "tree",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('allEnq')
      }
    }
  }, [_vm._v("Total Enquiry\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.enqDataCount[0].totalEnquiry) + "\n                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E1')
      }
    }
  }, [_vm._v("Enquiry From Existing Clients\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.enqDataCount[0].ExistClientEnquiry) + "\n                          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11')
      }
    }
  }, [_vm._v("Sea Shipment\n                                "), _c('br'), _vm._v("\n                                " + _vm._s(_vm.enqDataCount[0].ExistClientSeaEnquiry) + "\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11Export')
      }
    }
  }, [_vm._v("Sea Export\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.enqDataCount[0]
    .ExistClientSeaExportEnquiry) + "\n                                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11ExportTPT')
      }
    }
  }, [_vm._v("TPT\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientTPTSeaExportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11ExportFF')
      }
    }
  }, [_vm._v("FF\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientFFSeaExportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11ExportCC')
      }
    }
  }, [_vm._v("CC\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientCCSeaExportEnquiry) + "\n                                      ")])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11Import')
      }
    }
  }, [_vm._v("Sea Import\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.enqDataCount[0]
    .ExistClientSeaImportEnquiry) + "\n                                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11ImportTPT')
      }
    }
  }, [_vm._v("TPT\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientTPTSeaImportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11ImportFF')
      }
    }
  }, [_vm._v("FF\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientFFSeaImportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E11ImportCC')
      }
    }
  }, [_vm._v("CC\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientCCSeaImportEnquiry) + "\n                                      ")])])])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12')
      }
    }
  }, [_vm._v("Air Shipment\n                                "), _c('br'), _vm._v("\n                                " + _vm._s(_vm.enqDataCount[0].ExistClientAirEnquiry) + "\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12Export')
      }
    }
  }, [_vm._v("Air Export\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.enqDataCount[0]
    .ExistClientAirExportEnquiry) + "\n                                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12ExportTPT')
      }
    }
  }, [_vm._v("TPT\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientTPTAirExportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12ExportFF')
      }
    }
  }, [_vm._v("FF\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientFFAirExportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12ExportCC')
      }
    }
  }, [_vm._v("CC\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientCCAirExportEnquiry) + "\n                                      ")])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12Import')
      }
    }
  }, [_vm._v("Air Import\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.enqDataCount[0]
    .ExistClientAirImportEnquiry) + "\n                                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12ImportTPT')
      }
    }
  }, [_vm._v("TPT\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientTPTAirImportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12ImportFF')
      }
    }
  }, [_vm._v("FF\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientFFAirImportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('E12ImportCC')
      }
    }
  }, [_vm._v("CC\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .ExistClientCCAirImportEnquiry) + "\n                                      ")])])])])])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L2')
      }
    }
  }, [_vm._v("Enquiry From Leads\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.enqDataCount[0].LeadClientEnquiry) + "\n                          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21')
      }
    }
  }, [_vm._v("Sea Shipment\n                                "), _c('br'), _vm._v("\n                                " + _vm._s(_vm.enqDataCount[0].LeadSeaEnquiry) + "\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21Export')
      }
    }
  }, [_vm._v("Sea Export\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.enqDataCount[0].LeadSeaExportEnquiry) + "\n                                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21ExportTPT')
      }
    }
  }, [_vm._v("TPT\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadTPTSeaExportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21ExportFF')
      }
    }
  }, [_vm._v("FF\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadFFSeaExportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21ExportCC')
      }
    }
  }, [_vm._v("CC\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadCCSeaExportEnquiry) + "\n                                      ")])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21Import')
      }
    }
  }, [_vm._v("Sea Import\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.enqDataCount[0].LeadSeaImportEnquiry) + "\n                                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21ImportTPT')
      }
    }
  }, [_vm._v("TPT\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadTPTSeaImportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21ImportFF')
      }
    }
  }, [_vm._v("FF\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadFFSeaImportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L21ImportCC')
      }
    }
  }, [_vm._v("CC\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadCCSeaImportEnquiry) + "\n                                      ")])])])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22')
      }
    }
  }, [_vm._v("Air Shipment\n                                "), _c('br'), _vm._v("\n                                " + _vm._s(_vm.enqDataCount[0].LeadAirEnquiry) + "\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22Export')
      }
    }
  }, [_vm._v("Air Export\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.enqDataCount[0].LeadAirExportEnquiry) + "\n                                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22ExportTPT')
      }
    }
  }, [_vm._v("TPT\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadTPTAirExportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22ExportFF')
      }
    }
  }, [_vm._v("FF\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadFFAirExportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22ExportCC')
      }
    }
  }, [_vm._v("CC\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadCCAirExportEnquiry) + "\n                                      ")])])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22Import')
      }
    }
  }, [_vm._v("Air Import\n                                    "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.enqDataCount[0].LeadAirImportEnquiry) + "\n                                  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22ImportTPT')
      }
    }
  }, [_vm._v("TPT\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadTPTAirImportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22ImportFF')
      }
    }
  }, [_vm._v("FF\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadFFAirImportEnquiry) + "\n                                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToDetails('L22ImportCC')
      }
    }
  }, [_vm._v("CC\n                                        "), _c('br'), _vm._v("\n                                        " + _vm._s(_vm.enqDataCount[0]
    .LeadCCAirImportEnquiry) + "\n                                      ")])])])])])])])])])])])])])])])], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-pages",
      "md-label": "Sales Execution Reports"
    }
  }, [_c('viewBilling')], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b88db4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/dashboardReports.vue
// module id = 2352
// module chunks = 0